// extracted by mini-css-extract-plugin
export default {"containerStyle":"Video_containerStyle__ZNPBd","imageBorder":"Video_imageBorder__AsxdH","VideoContainer":"Video_VideoContainer__xVnkB","imageStyle":"Video_imageStyle__35ERm"};